import './Form.css';
import React from 'react';
import classnames from 'classnames';
import GlobalProps from '../globalProps';
import { SubmitLine } from '../SubmitLine/SubmitLine';
import { Button, ButtonProps } from '../Button/Button';
import { t } from '../../locales/translate';
import { Stack } from '../Stack/Stack';

export interface Props extends GlobalProps {
  autoComplete?: boolean;
  canSubmit?: boolean;
  loading?: boolean;
  saveButtonTitle?: string;
  cancelButtonTitle?: string;
  hideCancel?: boolean;
  hideSubmit?: boolean;
  buttonSize?: ButtonProps['size'];
  onClose?: () => void;
  onSubmit?: () => void;
  preventDefault?: boolean;
}

export function FormForm({
  style,
  className,
  children,
  autoComplete,
  loading,
  saveButtonTitle,
  cancelButtonTitle,
  onClose,
  onSubmit,
  canSubmit,
  hideCancel,
  hideSubmit,
  buttonSize = 'medium',
  preventDefault,
}: Props): JSX.Element {
  return (
    <form
      className={classnames('form', className)}
      style={style}
      noValidate
      autoComplete={autoComplete ? undefined : 'off'}
      onSubmit={(e) => {
        if (preventDefault) {
          e.preventDefault();
        }
        onSubmit?.();
      }}
    >
      <Stack>
        {children}
        <SubmitLine>
          {!hideCancel && (
            <Button title={cancelButtonTitle ?? t.actions.cancel('')} onClick={onClose} size={buttonSize} />
          )}
          {!hideSubmit && (
            <Button
              title={saveButtonTitle ?? t.actions.save('')}
              type="primary"
              loading={loading}
              disabled={!canSubmit}
              onClick={onSubmit}
              size={buttonSize}
            />
          )}
        </SubmitLine>
      </Stack>
    </form>
  );
}
